<template>
  <task-list-page></task-list-page>
</template>

<script>
import TaskListPage from '@/modules/tasks/pages/TaskListPage'
export default {
  components: { TaskListPage }
}
</script>



// WEBPACK FOOTER //
// src/modules/tasks/pages/TaskGroupPage.vue